// Tuning constants for the app.
//
// The Apps Script webhook URL + secret below are the canonical (and
// only) backend endpoint. They ship inside the JS bundle — anyone who
// inspects the built source can read them. True protection requires a
// server-side proxy that holds the secret; this file is a deliberate
// compromise until that migration happens (cf. long-term Supabase plan).
//
// Card-list sources live in `./lists.ts`, not here — each list carries
// its own CSV URL so multi-list support can grow without touching this
// module.

export const WEBHOOK_URL =
  "https://script.google.com/macros/s/AKfycby63SySwMi5eEzw-kjMvJVvW38zjujWKkiqjelB_jqy_xKpScWEtz-umYB04AViOYkZ/exec";

export const WEBHOOK_SECRET =
  "7wskgOMbakULJl3h2zQSp3AVm7q6LvLW5YuHhlHapI8JhFbQWs07cmXeCF6dD74c";

// CEFR difficulty levels (ordered easy → hard).
export const LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"] as const;
export type Level = (typeof LEVELS)[number];
export const DEFAULT_LEVEL: Level = "A1";

// 70% success on a level → user is at that level.
export const LEVEL_PROMOTE_THRESHOLD = 0.7;
// Minimum sample size before a level "counts".
export const LEVEL_MIN_ATTEMPTS = 15;

// Leitner box intervals (in milliseconds). Box 1 = always due.
const DAY = 24 * 60 * 60 * 1000;
export const BOX_INTERVALS = [0, 1 * DAY, 3 * DAY, 7 * DAY, 14 * DAY];
